<template>
	<!--	TODO clear error logs on change! -->
	<div class="main">
		<header class="page-title">
			<h2>New Provider List</h2>
			<div class="ml-auto">
				<a @click.prevent="saveProviderList" href="#" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="flex box">
			<div class="six-lg">
				<div class="card">
					<header class="card-header">
						<h4 class="card-title">General</h4>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="name">List Name</label>
							<input id="name" type="text" name="name" v-model="providerList.name">
							<p class="input-error" v-if="errors.errors.name">{{ errors.errors.name }}</p>
						</div>
						<div class="form-group">
							<label for="provider-type">Provider Type</label>
							<select id="provider-type" v-model="providerList.provider_type_id">
								<option v-for="type in types" :selected="type.id === providerList.provider_type_id" :value="type.id">{{ type.name }}</option>
							</select>
						</div>
						<div class="form-group">
							<label for="description">Internal Description</label>
							<textarea id="description" class="textarea-small" name="description" v-model="providerList.description"></textarea>
						</div>
					</div>
				</div>
			</div>
			<div class="six-lg">
				<div class="card">
					<header class="card-header">
						<h4 class="card-title">Order of Providers</h4>
					</header>
					<div class="card-body">
						<table>
							<thead>
								<tr>
									<th></th>
									<th>Position</th>
									<th>Provider Name</th>
									<th>Actions</th>
								</tr>
							</thead>
							<draggable :element="'tbody'" @end="drag=false" @start="drag=true" @update="onUpdate" :list="providerList.rows">
								<tr class="draggable" v-for="(row,index) in providerList.rows">
									<td class="text-center"><i class="fas fa-grip-lines"></i></td>
									<td>{{ row.no }}.</td>
									<td>
										<select v-model="row.selectedProvider">
											<option value="null">Select Provider</option>
											<option v-for="providerOption in providerOptions" :value="providerOption.id">{{ providerOption.name }}</option>
										</select>
										<p class="input-error" v-if="errors.errors[errorSelectProvider(index)]">{{ errors.errors[errorSelectProvider(index)] }}</p>
									</td>
									<td class="nowrap">
										<a href="#" class="btn btn-icon btn-danger" @click.prevent="removeOption(index)"><i class="fas fa-times" title="Remove"></i></a>
									</td>
								</tr>
							</draggable>
						</table>
						<div class="mt-2 text-right">
							<button class="btn btn-md btn-success" @click="addOption">
								<i class="fas fa-plus"></i> Add New Provider
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import Errors from '../../Utils/Errors.js';

export default {
	component: {
		draggable,
	},
	props: {
		dataTypes: {
			type: Array
		},
		dataProviders: {
			type: Array
		},
		dataArticleId: {
			type: Number
		},
		dataArticleData: {
			type: Object
		}
	},
	data() {
		return {
			types: this.dataTypes,
			providers: this.dataProviders,

			providerList: {
				name: this.dataArticleData ? this.dataArticleData.title : null,
				provider_type_id: 1,
				description: this.dataArticleData ? 'Post-specific provider list' : null,
				rows: [{
					no: 1,
					selectedProvider: null
				}],
				article_id: this.dataArticleId ? this.dataArticleId : null
			},

			errors: new Errors()
		}
	},
	computed: {
		providerOptions: function () {
			let populateProviderOptions = [];
			for (let i = 0; i < this.providers.length; i++) {
				if (this.providers[i].provider_type_id === this.providerList.provider_type_id) {
					populateProviderOptions.push(this.providers[i]);
				} // if
			} // for
			return populateProviderOptions;
		}
	},
	methods: {
		addOption: function () {
			this.providerList.rows.push(
					{
						no: this.providerList.rows.length + 1,
						selectedProvider: null
					});
		},
		removeOption: function (index) {
			this.providerList.rows.splice(index, 1);
			this.updateRowsOrder()
		},
		onUpdate: function () {
			this.updateRowsOrder();
		},
		updateRowsOrder: function () {
			// reset the order to be 1,2,3 always
			let i = 1;
			this.providerList.rows.forEach(function (part, key) {
				this[key]["no"] = i;
				i++;
			}, this.providerList.rows);
		},
		saveProviderList: function () {
			let selectedSite = this.$selectedSite.slug;

			axios.post('/api/' + this.$selectedSite.slug + '/provider-list', this.providerList)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('Provider List saved successfully', 'Success');
							setTimeout(function () {
								window.location.replace('/' + selectedSite + '/provider-lists/' + response.data.provideList.id + '/edit?tab=general');
							}, 1000);
						} else {
							this.$toastr.error(response.data.failed, 'Error');
						} // if
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Provider List save failed.', 'Error');
					});
		},
		errorSelectProvider: function (index) {
			return 'rows_' + index + '_selectedProvider';
		}
	}
}
</script>

<style scoped>

</style>
